(function () {
    window.lazyFunctions = {}

    $ (function () {
        // глобальный селектор

        let lazyLoad = new LazyLoad({
            elements_selector: '.lazy'
        })


        // контент (не картинки)
        // по селектору .lazy-content будет проверяться, зарегистрирован ли колбэк
        // название функции-колбэка задавать в параметре data-lazy-function у элемента с классом .lazy-content и
        // дополнительно зарегистрировать её в глобальную область видимости примерно так:
        // window.lazyFunctions = window.lazyFunctions || {};
        // window.lazyFunctions.kealabs = function() { ... };
        let lazyloadContent = new LazyLoad({
            elements_selector: '.lazy-content',
            unobserve_entered: true,
            callback_enter: executeLazyFunction,
        })

        function executeLazyFunction(element) {
            let lazyFunctionName = element.getAttribute("data-lazy-function")
            let lazyFunction = window.lazyFunctions[lazyFunctionName]
            if (!lazyFunction) return
            lazyFunction(element)
        }


        // кастомные случаи

        let lazyLoadHeader = new LazyLoad({
            elements_selector: '.lazy-header'
        })
        $(document).on('lazyloadheader', '.js-header-nav', e => { // триггерится в компоненте site-header
            lazyLoadHeader.update()
        })

        let lazyLoadBookPreview = new LazyLoad({
            elements_selector: '.lazy-book-preview',
            unobserve_entered: true,
            unobserve_completed: true
        })
        $(document).on('lazyloadbooks reinitItems.books', e => { // триггерится при динамических подгрузках старых превью книг
            lazyLoadBookPreview.update()
        })

        let lazyLoadBlogItems = new LazyLoad({
            elements_selector: '.lazy-blog-items'
        })
        $(document).on('lazyloadblogitems', e => { // триггерится при подгрузке статей в списке блога
            lazyLoadBlogItems.update()
        })

        let lazyLoadPost = new LazyLoad({
            elements_selector: '.lazy-post'
        })
        $(document).on('lazyloadpost', e => { // триггерится при подгрузке следующей статьи блога
            lazyLoadPost.update()
        })
        
        let lazyLoadBookPage = new LazyLoad({
            elements_selector: '.lazy-book-slider',
            unobserve_entered: true,
            unobserve_completed: true
        })
        $(document).on('lazyloadbookpage', e => { // триггерится при переключении слайдера на странице книги
            lazyLoadBookPage.update()
        })
    })
}());
